'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.controller('buttonCtrl', function ($scope, $ionicModal) {
    $scope.modals = {};
    $scope.showModal = function (key) {
      if (!$scope.modals[key]) {
        $scope.modals[key] = $ionicModal.fromTemplate(require('./modal' + key + '.html'), { scope: $scope });
      }
      $scope.modals[key].show();
    };
    $scope.hideModal = function (key) {
      if ($scope.modals[key]) {
        $scope.modals[key].hide();
      }
    };
  });
  return app;
};

; /**
   * button
   */


//////////////////
// WEBPACK FOOTER
// ./src/pages/button/index.ctrl.js
// module id = 44
// module chunks = 0